// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Core__Option = require("@rescript/core/src/Core__Option.bs.js");

function tapNone(opt, fn) {
  if (opt === undefined) {
    fn();
  }
  return opt;
}

function tapSome(opt, fn) {
  Core__Option.forEach(opt, fn);
  return opt;
}

function toString(opt) {
  if (opt !== undefined) {
    return opt;
  } else {
    return "";
  }
}

function ofString(str) {
  if (str === "") {
    return ;
  } else {
    return str;
  }
}

var filter = Core__Option.filter;

var forEach = Core__Option.forEach;

var getExn = Core__Option.getExn;

var mapOr = Core__Option.mapOr;

var mapWithDefault = Core__Option.mapWithDefault;

var map = Core__Option.map;

var flatMap = Core__Option.flatMap;

var getOr = Core__Option.getOr;

var getWithDefault = Core__Option.getWithDefault;

var orElse = Core__Option.orElse;

var isSome = Core__Option.isSome;

var isNone = Core__Option.isNone;

var equal = Core__Option.equal;

var compare = Core__Option.compare;

exports.filter = filter;
exports.forEach = forEach;
exports.getExn = getExn;
exports.mapOr = mapOr;
exports.mapWithDefault = mapWithDefault;
exports.map = map;
exports.flatMap = flatMap;
exports.getOr = getOr;
exports.getWithDefault = getWithDefault;
exports.orElse = orElse;
exports.isSome = isSome;
exports.isNone = isNone;
exports.equal = equal;
exports.compare = compare;
exports.tapNone = tapNone;
exports.tapSome = tapSome;
exports.toString = toString;
exports.ofString = ofString;
/* No side effect */
